module.exports = __webpack_public_path__ + "static/media/lato-black.e83ea59e.woff";